module.exports = fox._r("fonts/activity.svg", __webpack_public_path__ + "_/_/_/root/fonts/activity.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/activity.svg
// module id = 389
// module chunks = 4